import type { SideLabel } from "../services/generated/client.js";

/**
 * Who a side is, or `null` if the party no longer knows.
 *
 * A pure lookup rather than a `find` written out at each call site, because
 * there are three call sites — the phone's board, the television's, and the
 * pre-game roster — and they must agree about the absent case.
 *
 * # Absent means they left
 *
 * The roster is built from `members::present`, which filters `left_at IS NULL`.
 * So a side in a running game with no label is a player who left the party, and
 * that is worth saying out loud: over a call, *"why is nobody answering for that
 * timeline"* is a real question with a real answer, and a blank heading answers
 * it with a shrug.
 */
export function sideLabel(
  roster: readonly SideLabel[],
  sideId: string,
): SideLabel | null {
  return roster.find((label) => label.side === sideId) ?? null;
}
